import { FASTElement as d, observable as h, attr as u } from "@microsoft/fast-element";
import { ratingStyles as c } from "./rating.styles.js";
import { ratingTemplate as p } from "./rating.template.js";
import { NumberStringConverter as m } from "../common/converters/number-string-converter.js";
var v = Object.defineProperty, r = (l, e, a, g) => {
  for (var i = void 0, n = l.length - 1, o; n >= 0; n--)
    (o = l[n]) && (i = o(e, a, i) || i);
  return i && v(e, a, i), i;
}, t;
const s = (t = class extends d {
  constructor() {
    super(...arguments), this.renderedValue = 0, this.value = 0, this.previousValue = -1, this.actionable = !1;
  }
  starsChanged() {
    this.updateRatingStars();
  }
  valueChanged() {
    this.value < t.minValue ? this.value = t.minValue : this.value > t.maxValue && (this.value = t.maxValue), this.renderedValue = this.value, this.updateRatingStars();
  }
  actionableChanged() {
    this.updateRatingStars();
  }
  updateRatingStars(e = this.value) {
    if (this.$fastController.isConnected)
      for (let a = 0; a < this.stars.length; a++)
        a < e ? this.stars[a].classList.add("rating-star-active") : this.stars[a].classList.remove("rating-star-active");
  }
  handleRatingStarClick(e) {
    this.actionable && this.$emit("rating", e, { cancelable: !1 });
  }
  handleRatingStarMouseLeave() {
    this.actionable && (this.renderedValue = this.value, this.updateRatingStars());
  }
  handleRatingStarMouseOver(e) {
    this.actionable && (this.renderedValue = e, this.updateRatingStars(e));
  }
  connectedCallback() {
    super.connectedCallback(), this.updateRatingStars();
  }
}, t.minValue = 0, t.maxValue = 5, t.definition = {
  name: "rating",
  template: p,
  styles: () => c
}, t);
r([
  h
], s.prototype, "stars");
r([
  h
], s.prototype, "renderedValue");
r([
  u({ converter: m })
], s.prototype, "value");
r([
  u({ mode: "boolean" })
], s.prototype, "actionable");
let C = s;
export {
  C as Rating
};
